import React, { useEffect } from "react";
import { Provider, useSelector } from "react-redux";
import store from "./redux/store";
import { HashRouter as Router } from "react-router-dom";
import Views from "./views";
import { Route, Switch } from "react-router-dom";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import { THEME_CONFIG } from "./configs/AppConfig";
import {
	getCssSwitcherKey,
	isValidStoredTheme,
	THEME_KEYS,
} from "utils/themeDisplay";
import useVersionChecker from "utils/hooks/useVersionChecker";

const themes = {
	dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
	light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

function getDefaultSwitcherTheme() {
	if (typeof window !== "undefined") {
		const saved = localStorage.getItem("theme");
		if (isValidStoredTheme(saved)) {
			return getCssSwitcherKey(saved);
		}
	}
	return getCssSwitcherKey(THEME_CONFIG.currentTheme);
}

function ThemeAccentClassSync() {
	const currentTheme = useSelector((s) => s.theme.currentTheme);
	useEffect(() => {
		document.documentElement.classList.toggle(
			"theme-accent-questor",
			currentTheme === THEME_KEYS.QUESTOR,
		);
	}, [currentTheme]);
	return null;
}

function App() {
	useVersionChecker();

	return (
		<div className="App">
			<Provider store={store}>
				<ThemeAccentClassSync />
				<ThemeSwitcherProvider
					themeMap={themes}
					defaultTheme={getDefaultSwitcherTheme()}
					insertionPoint="styles-insertion-point"
				>
					<Router>
						<Switch>
							<Route path="/" component={Views} />
						</Switch>
					</Router>
				</ThemeSwitcherProvider>
			</Provider>
		</div>
	);
}

export default App;
